export function numberMaxLength() {

    return {
        require: 'ngModel',
        link: function (scope, element, attrs, ctrl) {

            ctrl.$validators.numberMaxLength = function (modelValue, viewValue) {

                if (modelValue == null) {

                    return true;
                }

                const amount = Math.log10(Math.abs(modelValue));

                return amount < (attrs.numberMaxLength - 2);
            };
        }
    };
}



// WEBPACK FOOTER //
// ./src/ui/directives/number-max-length.directive.js